import ve from '../assets/images/countries/venezuela.png';
import us from '../assets/images/countries/usa.png';
import co from '../assets/images/countries/colombia.png';
import cl from '../assets/images/countries/chile.png';
import sv from '../assets/images/countries/elsalvador.png';

export default function CountryFlag({country})
{
    let flag = '';
    country = country.toLowerCase();

    if(country === 've')
        flag=ve;
    else if(country === 'us')
        flag=us;
    else if(country === 'co')
        flag=co;
    else if(country === 'cl')
        flag=cl;
    else
        flag=sv;

    return(
        <img style={{width:25}} src={flag} alt={country}/>
    )
}